import React, { useCallback, useState } from 'react'

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  RadioGroup,
} from '@material-ui/core'
import MuiRadio from '@material-ui/core/Radio'
import { useFormContext } from 'react-hook-form'

type RadioProps = {
  name: string
  label?: string
  disabled?: boolean
  icon: React.ElementType<React.SVGProps<SVGSVGElement>>
  options: Array<{
    name: string
    value: string
  }>
}

const Radio: React.FC<RadioProps> = ({
  name,
  label,
  disabled,
  options,
  icon: Icon,
}) => {
  const { register, errors, watch, setValue } = useFormContext()

  const value = watch(name)
  const isError = !!errors[name]
  const helperText = errors[name]?.message

  const handleChangeValue = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, newValue: string) => {
      setValue(name, newValue)
    },
    [setValue, name],
  )

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item>
        <Icon />
      </Grid>
      <Grid item>
        <FormControl component="fieldset" error={isError} disabled={disabled}>
          {label && (
            <FormLabel component="legend" className="py-2">
              {label}
            </FormLabel>
          )}
          <RadioGroup
            aria-label={name}
            name={name}
            value={value}
            onChange={handleChangeValue}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<MuiRadio inputRef={register} />}
                label={option.name}
              />
            ))}
          </RadioGroup>
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      </Grid>
    </Grid>
  )
}

export default Radio
